import { createContext, useContext } from "react";

import { BookingCalendarScreenModel } from "./BookingCalendarScreenModel.ts";

export const BookingCalendarScreenContext =
  createContext<BookingCalendarScreenModel>({} as BookingCalendarScreenModel);

export const useBookingCalendarScreenContext = () =>
  useContext(BookingCalendarScreenContext);
